export default {
  evaluation_list: {
    title: 'Liste des fournisseurs',
    // number_of_companies_answered: "",
    number_of_companies_displayed: 'Afficher {start} à {end} sur {total} entreprises',
    company_name: "Nom de l'entreprise",
    status: 'Statut',
    questionnaire: 'Enquête',
    plan: 'Plan',
    nothing: 'Aucun résultat trouvé',
  },
  evidence_options: {
    all_plan: 'Tous les plans',
    // plans_with_vouchers: "",
    // no_voucher_plan: "",
  },
  table_headers: {
    company_name: "Nom de l'entreprise",
    status: 'Statut',
    esg_rating: 'Note ESG',
    esg_score: 'Score ESG',
    environment: 'Environnement',
    social: 'Social',
    governance: 'Gouvernance',
    plan: 'Plan',
    questionnaire: 'Enquête',
    answer_date: 'Date de la réponse',
    answer_expires_date: 'Délai',
  },
  plan_list: {
    // light: "",
    // starter: "",
    // basic: "",
    // standard: "",
    // enterprize: "",
  },
}
